<script>
  import {Bar, mixins} from 'vue-chartjs'

  const {reactiveProp} = mixins

  export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: ['width', 'height'],
    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true
            }]
          }
        }
      }
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/graficas/problemas/barProblemas.vue